<ng-template #hoverGif>
  <sb-slideshow [autoplay]="true" [hideArrows]="true" [hideIndicators]="true">
    @for (preview of previews; track $index) {
      <sb-comp-slide>
        @if (preview && preview.contentType && !preview.processing) {
          <sb-comp-medium
            [medium]="preview" [thumbnailSize]="thumbnailSize" [customWidth]="100+'%'" [customHeight]="100+'%'">
          </sb-comp-medium>
        }
      </sb-comp-slide>
    }
  </sb-slideshow>
</ng-template>

@if (previews && previews.length > 0) {
  <div class="slideAnimation" [ngbTooltip]="hoverPreview ? hoverGif : null"
       container="body" [openDelay]="500" [closeDelay]="500" placement="right top-right top"
       tooltipClass="tooltip-fullzize">
    <sb-slideshow #carousel [autoplay]="autoplay" [interval]="interval ?? 5000" [hideArrows]="hideArrows" [hideIndicators]="hideIndicators"
                  [maxWidth]="customWidth">
      @for (preview of previews; track $index) {
        <sb-comp-slide>
          @if (preview) {
            <div [ngStyle]="{'height': customHeight, 'width': customWidth }">
              <sb-comp-medium
                [customHeight]="customHeight" [customWidth]="customWidth"
                [medium]="preview" [background]="background" [showFullOnClick]="showFullOnClick"
                [thumbnailSize]="thumbnailSize" [still]="still">
              </sb-comp-medium>
            </div>
          }
        </sb-comp-slide>
      }
    </sb-slideshow>
  </div>
} @else {
  <div [ngStyle]="{'height': customHeight, 'width': customWidth }"
       [ngbTooltip]="hoverPreview ? translate.instant('lang.globals.noMedium') : null"
       placement="right top-right top" container="body"
       class="picBg picBg--small tw-flex tw-items-center tw-justify-center question-mark-bg">
    <span class="tw-font-bold">?</span>
  </div>
}
